/**
 * @file Purchase Album Photos Checkout Success view.
 */

import React from 'react';

import PurchaseAlbumPhotosCheckoutSuccessContainer from '../../containers/purchase/PurchaseAlbumPhotosCheckoutSuccessContainer';

const PurchaseAlbumPhotosCheckoutSuccessView = () => (
  <PurchaseAlbumPhotosCheckoutSuccessContainer />
);

export default PurchaseAlbumPhotosCheckoutSuccessView;
